import React, { useState } from 'react';
import GridCellWrapper from '../../../../components/grid-cell-wrapper/GridCellWrapper';
import { connect } from 'react-redux';
import Toolbar from '../../../../components/toolbar/Toolbar';
import DropDown from '../../../../components/dropdown/Dropdown';
import Button from '../../../../components/button/Button';
import { utcIsoDateToLocaleDate } from '../../../../utils/date';
import {
  getMondayOfTheWeek,
  getSaturdayOfTheWeek,
} from '../../../../utils/time';
import Select, { SelectOption } from '../../../../components/select/Select';
import { StateModel } from '../../../../redux/store';

const Zeitstrahl = () => {
  const [zeitabschnitt, setZeitabschnitt] = useState('');
  const [transportoptionId, setTransportoptionId] = useState(0);
  const tomorrow = new Date(Date.now());
  tomorrow.setDate(tomorrow.getDate() + 1);
  const heute = utcIsoDateToLocaleDate(new Date(Date.now()));
  const morgen = utcIsoDateToLocaleDate(tomorrow);
  const montag = utcIsoDateToLocaleDate(getMondayOfTheWeek());
  const samstag = utcIsoDateToLocaleDate(getSaturdayOfTheWeek());

  const testFahrzeuge = () => {
    return [
      {
        kennzeichen: 'BI DA 79',
        zugehoerige_einheit: 'Wechselbrücke 13',
        fahrer_in_name: 'Max Mustermann',
      },
      {
        kennzeichen: 'BI DA 178',
        zugehoerige_einheit: 'Anhänger 17',
        fahrer_in_name: 'Mia Musterfrau',
      },
      {
        kennzeichen: 'HF GD 9',
        zugehoerige_einheit: '',
        fahrer_in_name: 'Kim Musterdivers',
      },
      {},
      {},
      {},
    ];
  };

  const transport_optionen: SelectOption[] = [
    { elementId: 0, id: 0, value: 'Übersicht' },
    { elementId: 1, id: 1, value: 'Fuhrpark' },
    { elementId: 2, id: 2, value: 'Frachtführer' },
    { elementId: 3, id: 3, value: 'Speditionen' },
  ];

  const dispo_lanes = testFahrzeuge().map((fahrzeug, index) => {
    return (
      <li key={index}>
        <div className='dispo-lane'>
          <div className='transport-option'>
            <p>{fahrzeug.kennzeichen}</p>
            <p>{fahrzeug.zugehoerige_einheit}</p>
            <p>{fahrzeug.fahrer_in_name}</p>
          </div>
          <div className='time-lane'></div>
        </div>
      </li>
    );
  });

  return (
    <GridCellWrapper
      classes='zeitstrahl'
      label='Zeitstrahl'
      saveUserAnsicht={() => {
        null;
      }}
    >
      <Toolbar>
        <DropDown icon='fas fa-print fa-lg'>
          <span>CMR</span>
          <span>Speditionsauftrag</span>
          <span>Transportauftrag</span>
          <span>Lademittelschein</span>
          <span>Lieferschein</span>
          <span>Label</span>
          <span>Gefahrgutdokument</span>
        </DropDown>
        <Button tooltip={'Einstellungen'} key={0} classes={'iconButton'}>
          <i className='fas fa-cogs fa-lg' />
        </Button>
        <Button onClickHandler={() => setZeitabschnitt(heute + ' - ' + heute)}>
          heute
        </Button>
        <Button onClickHandler={() => setZeitabschnitt(heute + ' - ' + morgen)}>
          morgen
        </Button>
        <Button
          onClickHandler={() => setZeitabschnitt(montag + ' - ' + samstag)}
        >
          Werktagwoche
        </Button>
        <label>{zeitabschnitt}</label>
      </Toolbar>
      <div className='zeitstrahl-content'>
        <ul className='dispo-lanes'>
          <li className='zeitstrahl-header dispo-lane'>
            <div className='zeitstrahl-header-content'>
              <Select
                className='select-transport-option'
                onChangeHandler={value => setTransportoptionId(value ?? 0)}
                selectedOptionId={transportoptionId}
                selectData={transport_optionen}
              />
              <div className='zeiten'>
                <div className='tag'>
                  <p>Montag</p>
                  <p>21.06.2021</p>
                </div>
                <div className='tag'>
                  <p>Dienstag</p>
                  <p>22.06.2021</p>
                </div>
                <div className='tag'>
                  <p>Mittwoch</p>
                  <p>23.06.2021</p>
                </div>
              </div>
            </div>
          </li>
          {dispo_lanes}
        </ul>
      </div>
    </GridCellWrapper>
  );
};

const mapStateToProps = (state: StateModel) => ({
  resetToggle: state.Auftragserfassung.resetToggle,
});

export default connect(mapStateToProps, {})(Zeitstrahl);
